import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ChatInterface from "./components/ChatInterface";
import AuthModal from "./components/AuthModal";
import AdminDashboard from "./components/AdminDashboard";
import DocumentSearchPage from "./components/DocumentSearchPage";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(true);

  useEffect(() => {
    // Vérifier si l'utilisateur est déjà authentifié
    const authenticated = localStorage.getItem('beta_authenticated');
    if (authenticated === 'true') {
      setIsAuthenticated(true);
      setShowAuthModal(false);
    }
  }, []);

  const handleAuthenticated = (authenticated) => {
    setIsAuthenticated(authenticated);
    setShowAuthModal(!authenticated);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <AuthModal 
          isOpen={showAuthModal} 
          onAuthenticated={handleAuthenticated} 
        />
        <Routes>
          <Route 
            path="/" 
            element={
              <ChatInterface 
                isAuthenticated={isAuthenticated}
              />
            } 
          />
          <Route 
            path="/admin" 
            element={<AdminDashboard />} 
          />
          <Route 
            path="/documents" 
            element={<DocumentSearchPage />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;